'use strict';

angular.module('export')
    .component('exportList', {
        templateUrl: 'modules/export/components/list/content.html',
        controller: 'ExportListController',
    });
